
import React, { useContext, useState } from 'react';
import "./admindashboard.css";
import MeetingsCard from './MeetingsCard';
import UpcommingMeetingCard from './UpcommingMeetingCard';
import PreviousMeetingCard from './PreviousMeetingCard';

import { useNavigate } from 'react-router-dom';
import { contextData } from '../../context/ContextProvider';
import { useEffect } from 'react';

import { GET, POST } from '../Common/HttpMethods/HttpMethods';
import { Url } from '../../constants/ApiUrlConstants';
import FailModal from "../Common/Popups/FailModal";
import { FaCalendarAlt } from 'react-icons/fa';
import DatePicker from "react-datepicker";
import { SvgDiv } from './Mettings/MyMeetings/MyMeetings';
import moment from 'moment';
import { Cuurent_RBAC_roles, Cuurent_USER_ROLES, Cuurent_USERNAME } from '../CommonCase/CommonFunctions';

export const goToSetupMeeting = (isOrganizer, navigate, setActive) => {
  if (isOrganizer) {
    navigate("/main/meetings/setupmeeting");
    setActive('tab2');
  }
};


export const handleCloseFailModel = (setOpenFailModal) => {
  setOpenFailModal(false);
};

export const handleSessionExpClose = (sessionStorage, navigate, setActive) => {
  sessionStorage.clear();
  navigate('/login');
  setActive('tab1');
};

export const getDashboardData = async (
  token,
  setLoading,
  setUpcommingMeetings,
  setOngoingMeetingDetails,
  setPreviousMeetings,
  setSessionExpiredModal,
  setOpenFailModal,
  setFailMessage
) => {
  try {
    setLoading(true);

    // Use Promise.all to make all API calls concurrently
    const [upcomingMeetingsResp, ongoingMeetingsResp, previousMeetingsResp] = await Promise.all([
      POST(Url.getMeetingsByMeeetingType, token, { "meetingType": "upcoming" }),
      POST(Url.getMeetingsByMeeetingType, token, { "meetingType": "ongoing" }),
      POST(Url.getMeetingsByMeeetingType, token, { "meetingType": "previous" }),
    ]);

    if (upcomingMeetingsResp.SUCCESS) {
      setUpcommingMeetings(upcomingMeetingsResp.DATA);
    }
    if (ongoingMeetingsResp.SUCCESS) {
      setOngoingMeetingDetails(ongoingMeetingsResp.DATA);
    }
    if (previousMeetingsResp.SUCCESS) {
      setPreviousMeetings(previousMeetingsResp.DATA);
    }

    if (previousMeetingsResp.SUCCESS && ongoingMeetingsResp.SUCCESS && upcomingMeetingsResp.SUCCESS) {
      setLoading(false);
    } else if (previousMeetingsResp.STATUS === 401 || ongoingMeetingsResp.STATUS === 401 || upcomingMeetingsResp.STATUS === 401) {
      setLoading(false);
      setSessionExpiredModal(true);
      setFailMessage("Session expired");
    }else if (previousMeetingsResp.STATUS === 400 || ongoingMeetingsResp.STATUS === 400 || upcomingMeetingsResp.STATUS === 400) {
      setLoading(false);
      setSessionExpiredModal(true);
      setFailMessage("Session expired");
    }else if (previousMeetingsResp.STATUS === 403 || ongoingMeetingsResp.STATUS === 403 || upcomingMeetingsResp.STATUS === 403) {
      setLoading(false);
      setSessionExpiredModal(true);
      setFailMessage("Session expired");
    }else if (previousMeetingsResp.STATUS === 404 || ongoingMeetingsResp.STATUS === 404 || upcomingMeetingsResp.STATUS === 404) {
      setLoading(false);
      setSessionExpiredModal(true);
      setFailMessage("Session expired");
    }else if (previousMeetingsResp.STATUS === 500 || ongoingMeetingsResp.STATUS === 500 || upcomingMeetingsResp.STATUS === 500) {
      setLoading(false);
      setSessionExpiredModal(true);
      setFailMessage("Session expired");
    } else {
      setLoading(false);
      setOpenFailModal(true);
      setFailMessage("Failed To Fetch Meetings.");
    }
  } catch (error) {
    setLoading(false);
    setOpenFailModal(true);
    setFailMessage("Failed To Fetch Meetings.");
  }
};


export const handleRbacRoles = (userRole, storedRbacRoles, setRbac) => {
  if (userRole !== "USER") {
    const roleWithQMSDashboard = storedRbacRoles?.find(role => role.useCase === "QMS Dashboard");
    if (roleWithQMSDashboard) {
      setRbac(roleWithQMSDashboard);
    }
  }
};


const AdminDashboard = () => {
  let token = sessionStorage.getItem('TOKEN');

  const currentDate = new Date();

  const currentDatee = moment().format('YYYY-MM-DD');
  const currentYear = moment().year();
  const firstDateOfApril = (currentDatee >=  moment(`${currentYear}-04-01`).format('YYYY-MM-DD')) ? (moment(`${currentYear}-04-01`).format('YYYY-MM-DD')) : moment(`${currentYear-1}-04-01`).format('YYYY-MM-DD') ;


  // Extract day of the month
  const dayOfMonth = currentDate.getDate();

  // Extract month (returns a number from 0 to 11, where 0 is January and 11 is December)
  const month = currentDate.getMonth();

  const monthNames = [
    "January", "February", "March", "April", "May", "June",
    "July", "August", "September", "October", "November", "December"
  ];

  // Get the name of the month using the month number
  const monthName = monthNames[month];


  const navigate = useNavigate();
  const { setActive, active, setLoading } = useContext(contextData);
  const [upcomingMeetings, setUpcommingMeetings] = useState([]);
  const [ongoingMeetingDetails, setOngoingMeetingDetails] = useState([]);
  const [previousMeetings, setPreviousMeetings] = useState([]);

  const [openDashToDatePicker, setOpenDashToDatePicker] = useState(false);
  const [openDashFromDatePicker, setOpenDashFromDatePicker] = useState(false);

  const [selectedDashToDate, setSelectedDashToDate] = useState();
  const [selectedDashFromDate, setSelectedDashFromDate] = useState();

  // rbac roles
  let rrbac = Cuurent_RBAC_roles();
  const storedRbacRoles = JSON.parse(rrbac);
  const userRole = sessionStorage.getItem("USER")

  const [rbac, setRbac] = useState({});

  useEffect(() => {
    handleRbacRoles(userRole, storedRbacRoles, setRbac);
  }, []);

  let roles = Cuurent_USER_ROLES();
  let isOrganizer = roles?.includes("QMS Organizer");



  // ---------------------------------------------------------------------------Popup Utility----------------------------------------------------------------------
  const [openFailModal, setOpenFailModal] = useState(false);
  const [sessionExpiredModal, setSessionExpiredModal] = useState(false)
  const [failMessage, setFailMessage] = useState("");

  const [tagsMeetingLengths, setTagsMeetingLengths] = useState(
    {
      "facCnt": "00",
      "itCnt": "00",
      "deptCnt": "00",
      "govCnt": "00"
    })


  // ---------------------------------------------------------------------------Popup End----------------------------------------------------------------------



  useEffect(() => {
    getDashboardData(
      token,
      setLoading,
      setUpcommingMeetings,
      setOngoingMeetingDetails,
      setPreviousMeetings,
      setSessionExpiredModal,
      setOpenFailModal,
      setFailMessage
    );
  }, [])

  useEffect(() => {

    setSelectedDashFromDate(new Date(firstDateOfApril));
    setSelectedDashToDate(new Date(currentDatee));
  }, []);


  useEffect((item) => {
    if (selectedDashToDate) {
      getCountsOfTagsMeetings();
    }
  }, [selectedDashToDate, selectedDashFromDate]);



  const getCountsOfTagsMeetings = async () => {
    let allMeetingsBody = {
      startDate: moment(selectedDashFromDate).format('YYYY-MM-DD'),
      endDate: moment(selectedDashToDate).format('YYYY-MM-DD'),
      // meetType: "Count"
    };
    try {
      setLoading(true);
      let allTagsmeetingsResp = await POST(Url.getAllTagsOfMeetingWithCount, token, allMeetingsBody);
      setTagsMeetingLengths((prevState) => ({
        ...prevState,
        govCnt: allTagsmeetingsResp?.DATA?.govCnt,
        itCnt: allTagsmeetingsResp?.DATA?.itCnt,
        deptCnt: allTagsmeetingsResp?.DATA?.deptCnt,
        facCnt: allTagsmeetingsResp?.DATA?.facCnt,
      }));

      setLoading(false);
    } catch (error) {
     // setLoading(false);

    }
  };


  const handleDashboardDateChange = (name, date) => {
    if (name == "ToDate") {

      setSelectedDashToDate(date)
    }
    else {
      setSelectedDashFromDate(date)

    }
  }



  const username = Cuurent_USERNAME();

  const firstName = username ? username.split(" ")[0] : '';

  return (
    <div className='dashboard-main'>

      <div className="dashboard-left">
        <div className='dashboard-left-title-card-parent'>
          <div className="dashboard-left-title-card">
            <h4 className='title-role'>Hi, {firstName}</h4>
            <p className='title-description'>Welcome to the QMS Dashboard, Let's organize a meeting.</p>

          </div>
          <div style={{ opacity: 1, color: '#00ADEE', paddingBottom: '0px', font: " normal normal medium 20px/26px Futura PT", fontWeight: 500, fontSize: "14px", marginTop: "-11px" }} id='test-dashboard-ele'>Meeting History</div>
          <div className='dashboard-datepicker-parent-cont'>
            <div className='Dashboard-datepicker-and-colors-cont'>
              <div style={{ display: "flex", alignItems: 'center', justifyContent: "flex-start", }}>
                <div

                  style={{ display: "flex", justifyContent: "flex-start", alignItems: "center", padding: "0px 8px 0px 6px" }}
                >
                  <label htmlFor='recEndDateFrom'>From: </label>
                  <div style={{ width: "125px", display: "flex", justifyContent: "center", alignItems: "center", margin: "0 10px", border: "1px solid #B8B8B8", padding: "0px 0px 0px 5px", borderRadius: 4, color: "#B8B8B8", backgroundColor: "white" }}>
                    <SvgDiv DatePickerId={"1"} />
                    <DatePicker
                      id="recEndDateFrom"
                      name="recEndDate"
                      style={{ color: "#B8B8B8" }}
                      // open={openDashFromDatePicker}
                      maxDate={selectedDashToDate}
                      showTimeSelect={false}
                      selected={selectedDashFromDate}
                      onChange={(date) => {
                        const selectedTimestamp = selectedDashFromDate && selectedDashFromDate.getTime();
                        const dateTimestamp = date && date.getTime();
                        if (selectedTimestamp !== dateTimestamp) {
                          handleDashboardDateChange("FromDate", date);
                        }
                      }}
                      dateFormat="dd-MM-yyyy"
                    />

                  </div>

                </div>
                <div
                  style={{ display: "flex", justifyContent: "flex-start", alignItems: "center" }}
                >
                  <label htmlFor='recEndDate'>To: </label>
                  <div style={{ width: "125px", display: "flex", justifyContent: "center", alignItems: "center", margin: "0 10px", border: "1px solid #B8B8B8", padding: "0px 0px 0px 5px", borderRadius: 4, color: "#B8B8B8", backgroundColor: "white" }}>
                    <SvgDiv DatePickerId={"2"} />
                    <DatePicker
                      id="recEndDate"
                      name="recEndDate"
                      style={{ color: "#B8B8B8" }}
                      // open={openDashToDatePicker}
                      minDate={selectedDashFromDate}
                      showTimeSelect={false}
                      selected={selectedDashToDate}
                      onChange={(date) => {
                        const selectedTimestamp = selectedDashToDate && selectedDashToDate.getTime();
                        const dateTimestamp = date && date.getTime();
                        if (selectedTimestamp !== dateTimestamp) {
                          handleDashboardDateChange("ToDate", date);
                        }
                      }}
                      dateFormat="dd-MM-yyyy"
                    />

                  </div>

                </div>
              </div>
              <div className="colors-dash">
                <ul className='color-items-dash'>

                  <li className='color-item'>
                    <div className="color-dash hr-tag"></div>
                    <span>HR ({tagsMeetingLengths.deptCnt})</span>
                  </li>

                  <li className='color-item'>
                    <div className="color-dash governance-tag"></div>
                    <span>Governance ({tagsMeetingLengths?.govCnt})</span>
                  </li>

                  <li className='color-item'>
                    <div className="color-dash it-tag"></div>
                    <span>IT ({tagsMeetingLengths?.itCnt})</span>
                  </li>

                  <li className='color-item'>
                    <div className="color-dash facillity-tag"></div>
                    <span>Facillity ({tagsMeetingLengths?.facCnt})</span>
                  </li>

                </ul>
              </div>
            </div>
            {/* <div style={{ borderBottom: "1px solid", height: "height: 85.2%" }}> */}
            {isOrganizer ?
              //  <div className='Dashboard-setup-btn-cont'>
              <div data-testid="AdminDashSetup" style={{ boxShadow: "none", }} className="dashboard-left-title-card dash-right-title-card" onClick={() => goToSetupMeeting(isOrganizer, navigate, setActive)}>
                <h3 className='dashboard-setUp-meeting-title'><span style={{ marginTop: "3px" }}><FaCalendarAlt />
                </span> Setup New Meeting</h3>
              </div> : <div style={{ boxShadow: "none", }} className="dashboard-left-title-card-for-user dash-right-title-card-for-user"
              // onClick={() => goToSetupMeeting()}
              >
                <h3 className='dashboard-setUp-meeting-title'><span style={{ marginTop: "3px" }}><FaCalendarAlt />
                </span> Setup New Meeting</h3>
              </div>
              // </div>
            }




            {/* </div> */}

          </div>
        </div>


      </div>

      {/* ------------------------------------------------------------------setup meetings---------------------------------------------------------- */}
      <div className='Dashboard-Todays-UPM-Previous-container'>
        <div style={{ display: 'flex', flexDirection: 'column', marginRight: '4px', width: '99%' }}>
          <span style={{ opacity: 1, color: '#00ADEE', paddingBottom: '5px', font: " normal normal medium 20px/26px Futura PT", fontWeight: 500, fontSize: "14px" }} id='test-dashboard-ele'>Today's Meetings</span>
          <div className={ongoingMeetingDetails?.length > 0 ? "dashboard-left-card-container" : "empty-card"} style={{ height: ongoingMeetingDetails?.length > 0 ? "60vh" : "55%" }} >

            {
              ongoingMeetingDetails?.length > 0 ? ongoingMeetingDetails?.map((card, index) => {
                return (
                  <>
                    <MeetingsCard key={index} rbacRoles={rbac} card={card} />
                  </>
                )
              })
                :
                <h3 className='empty-message'>No Meetings Scheduled</h3>
            }
          </div>
        </div>
        <div className="dashboard-right">
          <div className="dashboard-right-bottom">
            <div className="upcomming-meetings-container">
              <div className='M-type-and-date-cont'> <h4 className="upcomming-meeting-header">
                Upcoming Meetings
              </h4>
                <span className='UPM-dayand-month'>{dayOfMonth + 1} {monthName}</span></div>

              <div className={upcomingMeetings?.length == 0 ? "empty-card" : "upcomming-meeting-list-container"}>
                {
                  upcomingMeetings?.length == 0 ? <h3 className='empty-message'>No Upcoming Meetings</h3>
                    :
                    upcomingMeetings?.map((meeting, index) => {
                      return (
                        <>
                          <UpcommingMeetingCard key={index} meeting={meeting} />
                        </>
                      )
                    })
                }

              </div>

            </div>
            <div className="previous-meetings-container">
              {/* <h4 className="upcomming-meeting-header">
              Previous Meetings
            </h4> */}
              <div className='M-type-and-date-cont'> <h4 className="upcomming-meeting-header">
                Previous Meetings
              </h4>
                <span className='UPM-dayand-month'>{dayOfMonth - 1} {monthName}</span></div>
              <div className={previousMeetings?.length == 0 ? "empty-card" : "upcomming-meeting-list-container"}>

                {
                  previousMeetings?.length == 0 ? <h3 className='empty-message'>No Previous Meetings</h3>
                    :
                    previousMeetings?.map((meeting, index) => {
                      return (
                        <>
                          <PreviousMeetingCard key={index} meeting={meeting} />
                        </>
                      )
                    })
                }
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* ---------------------------------------------------------------------------------POPUPS------------------------------------------------------- */}
      <FailModal
        openFailModal={openFailModal}
        setOpenFailModal={setOpenFailModal}
        failMessage={failMessage}
        setFailMessage={setFailMessage}
        recallFunctionOnOk={() => handleCloseFailModel(setOpenFailModal)} // Call the function directly
        recallFunctiononClose={() => handleCloseFailModel(setOpenFailModal)} // Call the function directly
      />

      <FailModal
        openFailModal={sessionExpiredModal}
        setOpenFailModal={setSessionExpiredModal}
        failMessage={failMessage}
        setFailMessage={setFailMessage}
        recallFunctionOnOk={() => handleSessionExpClose(sessionStorage, navigate, setActive)} // Call the function directly
        recallFunctiononClose={() => handleSessionExpClose(sessionStorage, navigate, setActive)} // Call the function directly
      />
    </div >
  )
}

export default AdminDashboard